import { useMemo } from "react";
import { TailSpin } from "react-loader-spinner";
import { SLIDES_BASE_URL } from "../constants";

import Timer from "./Timer";

function SlideDisplay({
  isSlidesLoading,
  slideUrl,
  isHidden,
  handleSlidePostMessage,
  numOfStudentsData,
  discussPhase,
  timerTimes,
  setDisableArrowControls,
  handleNavigation,
  timerModalInfo,
  setTimerModalInfo,
  setIsGamePlaying,
  isTutorialTooltipBlockingInputs,
  completeActiveTutorial,
  isOnFirstSlide,
  dispatchTeachEventLog,
}) {
  const validatedSlideUrl = useMemo(
    () => validateAndFormatUrl(slideUrl),
    [slideUrl]
  );

  const containerStyle = isHidden
    ? {
        zIndex: -1,
        opacity: "0%",
      }
    : { zIndex: 1, opacity: "100%" };

  return (
    <div id="slides-container" style={containerStyle}>
      {isSlidesLoading && (
        <TailSpin
          wrapperClass="tailspin-loader"
          height={100}
          width={100}
          color="#8a8a8a"
        />
      )}
      <iframe
        id="slide-deck"
        src={validatedSlideUrl}
        title="Slide Deck"
        allow="autoplay"
        onLoad={() => {
          handleSlidePostMessage("configure", [
            {
              controls: false,
              slideNumber: false,
              progress: false,
              overview: false,
            },
          ]);
        }}
        frameBorder="0"
        style={{ display: isSlidesLoading ? "none" : "block" }}
        tabIndex={-1}
      />
      {numOfStudentsData && <StudentsStatNum {...numOfStudentsData} />}
      {discussPhase && (
        <div id="timer-discuss-container" key={discussPhase}>
          <Timer
            type="discuss"
            phase={discussPhase}
            timerTimes={timerTimes}
            setDisableArrowControls={setDisableArrowControls}
            handleNavigation={handleNavigation}
            timerModalInfo={timerModalInfo}
            setTimerModalInfo={setTimerModalInfo}
            setIsGamePlaying={setIsGamePlaying}
            isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
            completeActiveTutorial={completeActiveTutorial}
            isOnFirstSlide={isOnFirstSlide}
            dispatchTeachEventLog={dispatchTeachEventLog}
          />
        </div>
      )}
    </div>
  );
}

export default SlideDisplay;

/** @todo enable different number colors for poll number according to slide theme? */
const StudentsStatNum = ({ type, number }) => (
  <div className="number-of-students-container">
    <span className={`number-of-students ${type}`}>{number}</span>
  </div>
);

function validateAndFormatUrl(slideUrl) {
  if (!slideUrl) {
    return;
  }

  if (typeof slideUrl !== "string") {
    throw new Error("Url is not a string");
  }

  const url = new URL(slideUrl);

  if (url.origin === SLIDES_BASE_URL) {
    // if formatted properly should split up to [empty, username, slidename, maybe embeded, empty]
    const [, username, slidename] = url.pathname.split("/");

    if (!username || !slidename) {
      throw new Error("Cannot embed slides, incorrect slide url format.");
    }

    url.pathname = `/${username}/${slidename}/embed/`;

    url.searchParams.set("postMessageEvents", true);
    url.searchParams.set("style", "hidden");
    url.searchParams.set("byline", "hidden");
    url.searchParams.set("share", "hidden");

    return url.href;
  } else {
    throw new Error("Embed slides is not from slides.com.");
  }
}
